<div class="register"
  [class.register--large]="currentStep == 4"
  >
  <app-logo
    [routerLink]="['/manage']"
  ></app-logo>
  <h2>{{ 'register.title' | transloco }}</h2>

  <app-progress-bar [progress]="((currentStep - 1) / 3) * 100"></app-progress-bar>

  <form [formGroup]="registerForm">
    @switch (currentStep) {
      <!-- Step 1: Basic Info -->
      @case (1) {
        <app-register-form-step name="register.step1.title">
          <div class="input-group">
            <label for="firstname">{{ 'register.firstname.label' | transloco }}</label>
            <input type="text" id="firstname" formControlName="firstname"
              [placeholder]="'register.firstname.placeholder' | transloco" />
            @if (registerForm.get('firstname')?.invalid && registerForm.get('firstname')?.touched) {
              <small class="error">
                {{ 'register.firstname.error' | transloco }}
              </small>
            }
          </div>
          <div class="input-group">
            <label for="lastname">{{ 'register.lastname.label' | transloco }}</label>
            <input type="text" id="lastname" formControlName="lastname"
              [placeholder]="'register.lastname.placeholder' | transloco" />
            @if (registerForm.get('lastname')?.invalid && registerForm.get('lastname')?.touched) {
              <small class="error">
                {{ 'register.lastname.error' | transloco }}
              </small>
            }
          </div>
          <div class="actions">
            <div></div>
            <button
              type="button"
              class="button button--large"
              [ngClass]="{ 'button--loading': nextLoading }"
              [disabled]="nextLoading || !registerForm.get('firstname')?.valid || !registerForm.get('lastname')?.valid"
              (click)="nextStep()"
              >
              {{ 'register.continue' | transloco }} <i class="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </app-register-form-step>
      }
      <!-- Step 2: Role -->
      @case (2) {
        <app-register-form-step name="register.step2.title">
          <div class="roles-options">
            <div class="button button-plan button--secondary button--role"
              (click)="selectRole(UserRoles.photographer)"
              >
              <i class="fa-solid fa-camera-retro"></i>
              <p class="title">{{'register.step2.roles.photographer.title'|transloco}}</p>
              <p class="description">{{'register.step2.roles.photographer.description'|transloco}}</p>
            </div>
            <div class="button button-plan button--secondary button--role"
              (click)="selectRole(UserRoles.customer)"
              >
              <i class="fa-solid fa-user"></i>
              <p class="title">{{'register.step2.roles.client.title'|transloco}}</p>
              <p class="description">{{'register.step2.roles.client.description'|transloco}}</p>
            </div>
          </div>
        </app-register-form-step>
        <div class="actions">
          <button
            type="button"
            class="button button--large button--secondary"
            (click)="prevStep()"
            >
            <i class="fa-solid fa-arrow-left"></i> {{ 'register.back' | transloco }}
          </button>
        </div>
      }
      <!-- Step 3: Login Info -->
      @case (3) {
        <app-register-form-step name="register.step3.title">
          <div class="input-group">
            <label for="email">{{ 'register.email.label' | transloco }}</label>
            <input type="email" id="email" formControlName="email"
              [placeholder]="'register.email.placeholder' | transloco" />
            @if (registerForm.get('email')?.invalid && registerForm.get('email')?.touched) {
              <small class="error">
                {{ 'register.email.error' | transloco }}
              </small>
            }
          </div>
          <div class="input-group">
            <label for="password">{{ 'register.password.label' | transloco }}</label>
            <input type="password" id="password" formControlName="password"
              [placeholder]="'register.password.placeholder' | transloco" />
            @if (registerForm.get('password')?.invalid && registerForm.get('password')?.touched) {
              <small class="error">
                {{ 'register.password.error' | transloco }}
              </small>
            }
          </div>
          <div class="input-group">
            <label for="passwordConfirm">{{ 'register.passwordConfirm.label' | transloco }}</label>
            <input type="password" id="passwordConfirm" formControlName="passwordConfirm"
              [placeholder]="'register.passwordConfirm.placeholder' | transloco" />
            @if (registerForm.hasError('passwordMismatch')) {
              <small class="error">
                {{ 'register.passwordConfirm.error' | transloco }}
              </small>
            }
          </div>
          <div class="actions">
            <button
              type="button"
              class="button button--large button--secondary"
              (click)="prevStep()"
              >
              <i class="fa-solid fa-arrow-left"></i> {{ 'register.back' | transloco }}
            </button>
            <button
              type="button"
              class="button button--large"
              [ngClass]="{ 'button--loading': nextLoading }"
              [disabled]="nextLoading || registerForm.get('email')?.invalid || registerForm.get('password')?.invalid || registerForm.hasError('passwordMismatch')"
              (click)="nextStep()"
              >
              {{ 'register.continue' | transloco }} <i class="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </app-register-form-step>
      }
      <!-- Step 4: Plan Selection -->
      <!--
      @case (4) {
        <app-register-form-step name="register.step4.title">
          <div class="subscription-options">
            <div class="subscription"
              [class.selected]="registerForm.get('selectedPlan')?.value === 'classic'"
              (click)="selectPlan('classic')"
              >
              <div class="subscription__checkbox"></div>
              <p class="subscription__name">
                {{ 'plan.starter.name' | transloco }}
              </p>
              <p class="subscription__description">
                {{ 'plan.starter.description' | transloco }}
              </p>
              @if (currentUser?.canGetFreeTrial) {
                <div class="price">
                  <p class="price__value">{{ 'plan.free'|transloco }}</p>
                  <p class="price__label">{{ 'plan.30-days' | transloco }}</p>
                </div>
                <p class="price__real">{{'plan.starter.real-price'|transloco}}</p>
              }
              @else {
                <div class="price">
                  <p class="price__value">{{ 'plan.starter.price'|transloco }}</p>
                  <p class="price__label">{{ 'pricing.per_month' | transloco }}</p>
                </div>
              }
              <ul class="features">
                <li><i class="fa-solid fa-check"></i> {{ 'pricing.advantages.public_page' | transloco }}</li>
                <li><i class="fa-solid fa-check"></i> {{ 'pricing.advantages.online_booking' | transloco }}</li>
                <li><i class="fa-solid fa-check"></i> {{ 'pricing.advantages.gallery_delivery' | transloco }}</li>
                <li><i class="fa-solid fa-check"></i> {{ 'pricing.advantages.stripe_payment' | transloco }}</li>
              </ul>
              <p class="and-more">{{'pricing.advantages.and-more'|transloco}}</p>
            </div>
            <div class="subscription"
              [class.selected]="registerForm.get('selectedPlan')?.value === 'pro'"
              (click)="selectPlan('pro')"
              >
              <div class="subscription__checkbox"></div>
              <div class="most-popular">
                <i class="fa-solid fa-star"></i>
                <p>{{ 'pricing.most_popular' | transloco }}</p>
              </div>
              <p class="subscription__name">
                {{ 'plan.pro.name' | transloco }}
              </p>
              <p class="subscription__description">
                {{ 'plan.pro.description' | transloco }}
              </p>
              @if (currentUser?.canGetFreeTrial) {
                <div class="price">
                  <p class="price__value">{{ 'plan.free'|transloco }}</p>
                  <p class="price__label">{{ 'plan.30-days' | transloco }}</p>
                </div>
                <p class="price__real">{{'plan.pro.real-price'|transloco}}</p>
              }
              @else {
                <div class="price">
                  <p class="price__value">{{ 'plan.pro.price'|transloco }}</p>
                  <p class="price__label">{{ 'pricing.per_month' | transloco }}</p>
                </div>
              }
              <ul class="features">
                <li><i class="fa-solid fa-check"></i> {{ 'pricing.advantages.stats' | transloco }}</li>
                <li><i class="fa-solid fa-check"></i> {{ 'pricing.advantages.marketplace_featured' | transloco }}</li>
                <li><i class="fa-solid fa-check"></i> {{ 'pricing.advantages.custom_domain' | transloco }}</li>
                <li><i class="fa-solid fa-check"></i> {{ 'pricing.advantages.verified_badge' | transloco }}</li>
              </ul>
              <p class="and-more">{{'pricing.advantages.and-more'|transloco}}</p>
            </div>
          </div>
          <div class="actions">
            @if (canGoBack()) {
              <button
                type="button"
                class="button button--large button--secondary"
                (click)="prevStep()"
              >
                <i class="fa-solid fa-arrow-left"></i> {{ 'register.back' | transloco }}
              </button>
            }
            @else {
              <div></div>
            }
            <button
              type="button"
              class="button button--large"
              (click)="subscribe()"
              [ngClass]="{ 'button--loading': nextLoading }"
              [disabled]="nextLoading"
              >
              {{ 'register.subscribe' | transloco }} <i class="fa-solid fa-arrow-right"></i>
            </button>
          </div>
        </app-register-form-step>
      }
      -->
    }

    <p class="create-account-link">
      {{ 'register.already_have_account' | transloco }}
      <a [routerLink]="['/login']">{{ 'register.login_now' | transloco }}</a>
    </p>
  </form>
</div>
